import { useSection } from "../Components/utils/SectionContext/SectionContext";
import Main from "../Main/Main";
import SkillsTechno from "../Components/SkillsTechno/SkillsTechno";

export default function Home() {
  const { activeSection } = useSection();
  return (
    <div id="homePage">
      <Main />
      {activeSection === "banners" && <SkillsTechno />}
    </div>
  );
}
